import React from "react";
import { Switch, Route } from "react-router-dom";
import CondicaoUnicaViews from "views/condicao-unica-views";

export const CondicaoUnicaLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={CondicaoUnicaViews} />
			</Switch>
		</div>
	);
};

export default CondicaoUnicaLayout;
